import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';

// In production the push handlers ride along inside the PWA service worker
// (see workbox.importScripts in vite.config.ts) — registering a second worker
// here would replace it, since both would share the root scope. In dev the
// PWA worker is disabled, so register the push worker standalone.
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-push.js').catch(() => {});
  });
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
